// extracted by mini-css-extract-plugin
export var faqAnswer = "FaqItem-module--faqAnswer--7df3f";
export var faqArrow = "FaqItem-module--faqArrow--93b98";
export var faqContainer = "FaqItem-module--faqContainer--d5e3d";
export var faqItem = "FaqItem-module--faqItem--58d7a";
export var faqOpen = "FaqItem-module--faqOpen--c0219";
export var faqQuestion = "FaqItem-module--faqQuestion--4ecdd";